import React, { Suspense } from "react";
import { useRoutes } from "react-router-dom";

import * as layoutConstants from "../constants/layout";

import { useSelector } from "react-redux";

import VerticalLayout from "../layouts/Vertical";
import DetachedLayout from "../layouts/Detached";
import HorizontalLayout from "../layouts/Horizontal";
import FullLayout from "../layouts/Full";

const DashBoard = React.lazy(() => import("../pages/DashboardHo"));
const Agentes = React.lazy(() => import("../pages/agentes/AgentesPg"));
const Preactivaciones = React.lazy(() => import("../pages/PreActivations"));
const Activaciones = React.lazy(() => import("../pages/Activaciones"));
const ChargesPg = React.lazy(() => import("../pages/ChargesPg"));
const Consultas = React.lazy(() => import("../pages/Consultas"));
const Store = React.lazy(() => import("../pages/InventarioPg"));
const Changeregion = React.lazy(() => import("../pages/soporte/CambioRegion"));
const Portabilidad = React.lazy(() => import("../pages/soporte/Portability"));
const ServicesLines = React.lazy(() =>
  import("../pages/soporte/LinesServices")
);
const BuzonVoz = React.lazy(() => import("../pages/soporte/BuzonVoz"));
const BlackImei = React.lazy(() => import("../pages/soporte/BlockIMEI"));
const ApnSend = React.lazy(() => import("../pages/soporte/ApnPg"));
const Config = React.lazy(() => import("../pages/ConfiguracionPg"));
const DataBase = React.lazy(() => import("../pages/DataBase"));
const Logs = React.lazy(() => import("../pages/Logs"));
const Roles = React.lazy(() => import("../pages/agentes/Rolespg"));
const Corte = React.lazy(() => import("../pages/finanzas/CorteRecargas"));

const loading = () => <div className=""></div>;

const LoadComponent = ({ component: Component }) => (
  <Suspense fallback={loading()}>
    <Component />
  </Suspense>
);

const AllRoutes = () => {
  const { auth, layout } = useSelector((state) => ({
    layout: state.Layout,
  }));

  const getLayout = () => {
    let layoutCls = VerticalLayout;

    switch (layout.layoutType) {
      case layoutConstants.LAYOUT_HORIZONTAL:
        layoutCls = HorizontalLayout;
        break;
      case layoutConstants.LAYOUT_DETACHED:
        layoutCls = DetachedLayout;
        break;
      case layoutConstants.LAYOUT_FULL:
        layoutCls = FullLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  };

  let Layout = getLayout();

  return useRoutes([
    {
      path: "/",
      element: <Layout />,
      children: [
        {
          path: "/",
          element: <LoadComponent component={ChargesPg} />,
        },
        {
          path: "dashboard",
          element: <LoadComponent component={DashBoard} />,
        },
        {
          path: "agentes",
          element: <LoadComponent component={Agentes} />,
        },
        {
          path: "preactivations",
          element: <LoadComponent component={Preactivaciones} />,
        },
        {
          path: "activations",
          element: <LoadComponent component={Activaciones} />,
        },
        {
          path: "charges",
          element: <LoadComponent component={ChargesPg} />,
        },
        {
          path: "search",
          element: <LoadComponent component={Consultas} />,
        },
        {
          path: "store",
          element: <LoadComponent component={Store} />,
        },
        {
          path: "changeregion",
          element: <LoadComponent component={Changeregion} />,
        },
        {
          path: "portability",
          element: <LoadComponent component={Portabilidad} />,
        },
        {
          path: "serviceslines",
          element: <LoadComponent component={ServicesLines} />,
        },
        {
          path: "resetpass",
          element: <LoadComponent component={BuzonVoz} />,
        },
        {
          path: "IMEI",
          element: <LoadComponent component={BlackImei} />,
        },
        {
          path: "apn",
          element: <LoadComponent component={ApnSend} />,
        },
        {
          path: "config",
          element: <LoadComponent component={Config} />,
        },
        {
          path: "database",
          element: <LoadComponent component={DataBase} />,
        },
        {
          path: "logs",
          element: <LoadComponent component={Logs} />,
        },
        {
          path: "roles",
          element: <LoadComponent component={Roles} />,
        },
        {
          path: "corte",
          element: <LoadComponent component={Corte} />,
        },
        {
          path: "/*",
          element: <LoadComponent component={ChargesPg} />,
        },
      ],
    },
  ]);
};

export { AllRoutes };
